import { isAvailableFeatureSelector } from 'features/billing'

export const isManagedEventTypesFeatureEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'managed_events' }
)

export const isManagedEventTypeLockingFeatureEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'managed_events_locking' }
)
